import React, { useContext, useState } from "react";
import { SThemeToggler, SToggleThumb, UsuarioLogado, RowTop, ColTop, Usuario } from "./styles";
import { AiOutlineLogout } from "react-icons/ai"
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../../App";

import empresasData from "../../../lib/json/empresas.json"
import { Col } from "react-bootstrap";
import SelectFixo from "../SelectFixo";

function TopDetail({onLogout}){
    const navigate = useNavigate();
    const { setTheme, theme } = useContext(ThemeContext);
    const [sidebarOpen, setSidebarOpen] = useState(false);
  
    const empresaFilial = localStorage.getItem('empresaFilial');
    const usuarioLogado = JSON.parse(localStorage.getItem('usuarioLogado'));
    
    const empresaLogado = empresasData.empresas.find((empresa) => empresa.empresaFilial === empresaFilial);
    const empresasFiltradas = empresasData.empresas.filter((empresa) => usuarioLogado.empresaHabilitadas.includes(empresa.empresaFilial));
  
    const options = empresasFiltradas.map((empresa) => ({
      value: empresa.empresaFilial,
      text: empresa.nomeEmpresa,
    }));
  
    const preSelectEmpFil = [{
        value: empresaLogado.empresaFilial,
        text: empresaLogado.nomeEmpresa,
    }];
    
    const handleChangeSelect = (selectedOption) => {
        localStorage.setItem('empresaFilial', selectedOption.value);

        // Assuming the values match the route paths
        if (selectedOption && selectedOption.value) {
            navigate(`/home`);
        }
    };

    const handleLogout = () => {
      onLogout();
    };
  
    return (    <>
        <RowTop>
            <Col className="d-flex justify-content-end" >
                <ColTop md='3'>
                    {/* <SelectFixo options={options} onChange={handleChangeSelect} selectedOptionValue={preSelectEmpFil}/> */}
                </ColTop>
                <ColTop md='3'>
                    <UsuarioLogado disabled={true}>
                        <Usuario>
                            {usuarioLogado.nome}
                        </Usuario>
                    </UsuarioLogado>
                </ColTop>
                <ColTop md='1'>
                    <AiOutlineLogout onClick={handleLogout} style={{margin: "8px 0"}} />
                </ColTop>
                <ColTop md='1'>
                    <SThemeToggler $isactive={theme === "dark"} style={{margin: "8px 0"}} onClick={() => setTheme((p) => (p === "light" ? "dark" : "light"))}>
                        <SToggleThumb $isactive={theme === "dark"} style={theme === "dark" ? { right: "1px" } : {}} />
                    </SThemeToggler>
                </ColTop>
            </Col>
        </RowTop>
    </>
    )
}

export default TopDetail;